import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
//import { IconButton, Tooltip } from '@mui/material';
//import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";

import introJs from 'intro.js';
import 'intro.js/introjs.css'
import '../../ccIntroJs/ccIntroJsStyles.css'
import { CcIntroJsStyledText } from '../../ccIntroJs/ccIntroJsStyledText';
import { showIntroJsTourForCurrentPage } from '../../ccIntroJs/ccIntroJsDisplayLogic';

export default function ProductHomeOSTracker() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        showIntroJsTourForCurrentPage(introJs)
    }, [])

    return <div>
            <CcTitle>
                App Match
            </CcTitle>
            <div className="mt-2 text-ccColorDarkTeal">Enhance relevance by matching the content you display to the operating system used to open the email. Ideal for displaying app download banners that match the user's device.</div>
            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Start here', mainText: 'This launches a wizard that creates your <span class="font-semibold">element</span><div class="mt-2">An <span class="font-semibold">element</span> is the html tag to copy into your email</div>'})}>
                <Link to={`/workflow/13`} style={linkStyle}>
                    <CcCreateNewSnippet className="mt-4" >Create new App Match</CcCreateNewSnippet>
                </Link>
            </div>

            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Elements section', mainText: '<div>List of all the Elements you created</div><div>You can edit an element even if you have already put it in a live email</div>'})}>
                <CcSubSectionTitle className=" mt-6">Latest App Match Elements</CcSubSectionTitle>
            </div>
            <SnippetsGrid productTypeId={13}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}